/**
 * Orders service
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.71.0 OAUI-685 Implement tabbed sections on table
 * 4.71.0 OAUI-684 Improve shared code and add interfaces
 * 4.71.0 OAUI-682 Rebuild list work/lookahead orders page and improve usability
 * 4.70.0 OAUI-678 Build "Driver Assignment" UI
 * 4.70.0 OAUI-679 Separate Shipping / Truck concepts
 * 4.70.0 OAUI-677 Add total price column on work orders
 * 4.69.0 OAUI-677 Add total price column on work orders
 * 4.68.0 OAUI-674 Show fulfillment groups for Lookahead Orders
 * 4.67.0 OAUI-667 Add item progress to Work Orders
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.62.0 OAUI-654 Remove calls to getOrderCrudApiRouting
 * 4.62.0 OAUI-653 Integrate delivery calendar time data
 * 4.61.0 OAUI-651 Show and hide shipping options based on status
 * 4.61.0 OAUI-643 Add material and gauge fields for adjustments
 * 4.59.0 OAUI-640 Add adjustments without fulfillment groups
 * 4.59.0 OAUI-613 Order Details: add Production Date Start and End
 * 4.58.0 OAUI-631 Tool item on Webduct order not showing on Order Details or PDFs
 * 4.55.0 OAUI-622 Fix updating job overrides in order details via orderApi
 * 4.55.0 OAUI-621 Fix minor parameter naming issue for modern order routing
 * 4.55.0 OAUI-619 Updating and deleting adjustments not calling endpoints correctly
 * 4.55.0 OAUI-618 Update the checkbox column to toggle on/off based on permissions
 * 4.55.0 OAUI-615 Remove PUT ordering-api calls to update cache
 * 4.54.0 OAUI-609 Add flag check to route API calls to order-api/core-api when updating orders
 * 4.52.0 OAUI-603 Improve order details layout with the addition of the shipping loading zone field
 * 4.52.0 OAUI-601 Add shipping/truck loading zone field into order details
 * 4.51.0 OAUI-599 Tool tracker items do not display in the order details
 * 4.49.0 OAUI-591 Restrict fabrication time, weight and pricing based on permissions
 * 4.48.0 OAUI-582 Add Date Range Filter for Orders
 * 4.47.0 OAUI-578 Add a fulfillment groups drop-down on the adjustments
 * 4.46.0 OAUI-577 Updating item shipping status shows "[object Object]"
 * 4.46.0 OAUI-572 Remove references to order-admin-api
 * 4.45.0 OAUI-570 Order Admin fulfillment status: style according to info from GraphQL call
 * 4.44.0 OAUI-564 Add button on Work Orders for CSV export
 * 4.43.0 OAUI-560 Order Admin Shipping status: style according to info from GraphQL call
 * 4.43.0 OAUI-563 Order details: add support for mongo based shipping options
 * 4.42.0 OAUI-555 Add dropdown to download attachments in work orders v2
 * 4.42.0 OAUI-554 Remove checks for deprecated app_vars (billing report, order-admin-ui v2)
 * 4.41.0 OAUI-549 Add shipping info to order details v2
 * 4.39.0 OAUI-541 Show insulation on order details v2 for fittings
 * 4.38.0 OAUI-538 Local storage is not working as expected
 * 4.38.0 OAUI-537 Toggle table columns on order list table
 * 4.38.0 OAUI-535 Style order rows based on order status
 * 4.37.0 OAUI-533 Multiple typeaheads with the same value not clearing properly
 * 4.37.0 OAUI-527 Slowdowns in order modals
 * 4.37.0 OAUI-532 Add missing filters for v2 orders list
 * 4.37.0 OAUI-528 Sometime the page title on the list orders page doesn't translate
 * 4.37.0 OAUI-525 Order Details V2: add support for Tool Tracker fulfillment group and items
 * 4.37.0 OAUI-476 Add filter for order types
 * 4.36.0 OAUI-517 Work Orders V2: add UI for adding a lookahead order
 * 4.36.0 OAUI-521 Add support to only show new reports on details/work orders V2
 * 4.36.0 OAUI-519 Add / Edit Adjustments
 * 4.36.0 OAUI-508 Missing "Model Viewer" section/link on new order details page
 * 4.36.0 OAUI-518 Add order reports and exports
 * 4.36.0 OAUI-515 Add / Edit / Remove Order Messages
 * 4.36.0 OAUI-504 Refactor how order messages are fetched from API
 * 4.36.0 OAUI-510 Add / Edit / Remove Attachments
 * 4.36.0 OAUI-509 Edit order shipping option
 * 4.36.0 OAUI-507 Edit order dates
 * 4.36.0 OAUI-506 Edit order job
 * 4.36.0 OAUI-502 Edit order details
 * 4.36.0 OAUI-505 Page number on top vs bottom navigation differs
 * 4.35.0 OAUI-500 View order adjustments
 * 4.35.0 OAUI-499 View Order Messages
 * 4.35.0 OAUI-498 View Order Fittings and Products by Fulfillment Group
 * 4.35.0 OAUI-496 Add header and missing fields
 * 4.35.0 OAUI-494 Update Ecommerce Job Overrides
 * 4.35.0 OAUI-493 Issues updating multiple jobs
 * 4.34.0 OAUI-491 Update order dates
 * 4.34.0 OAUI-492 Fulfillment groups display is stacking
 * 4.34.0 OAUI-489 Update multiple order statuses based on selection
 * 4.34.0 OAUI-488 Update fulfillment and shipping statuses
 * 4.34.0 OAUI-479 Optimize the list orders page to avoid overloaded SCSS files
 * 4.33.0 OAUI-473 Toggle Empty Fulfillment Groups based on Setting
 * 4.33.0 OAUI-471 Add report/export links for orders to Work Orders V2
 * 4.33.0 OAUI-462 Display order fulfillment groups
 * 4.33.0 OAUI-463 API call issues with orders listing v2
 * 4.33.0 OAUI-468 Remove duplicate calls for constants and hostConfiguration
 * 4.31.0 OAUI-460 Disable and hide count down timer on Work Orders listing v2
 * 4.31.0 OAUI-455 Add basic table to display orders
 * 4.31.0 OAUI-453 Set up basic list settings, filters and layout
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Jenny Lam <jlam@buildcentrix.com>
 *
 * @copyright (c) 2022-2024 Build Centrix
 */
import { Inject, Injectable } from '@angular/core';
import { isEqual } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { WdLocalSharedFunctionsService } from '../shared/wd-local-shared-functions.service';
import { WdLocalEnvironmentService } from '../environment/wd-local-environment.service';
import { SelectionModel } from '@angular/cdk/collections';
import {
  ITableColumnOptions,
  OrderShippingOptions,
} from '../../interfaces/orders/order-interfaces';
import { WdOrdersV2Service } from './wd-orders-v2.service';
import {
  IBcxDateTimeHelper,
  IBcxErrorService,
  IBcxOauth2HttpService,
  IBcxSharedFunctionsService,
  IBcxStorageService,
} from '../../interfaces/generic/generic-interfaces';

@Injectable({
  providedIn: 'root',
})
export class WdOrdersService {
  /**
   * Constructor Initialization
   * @since 4.33.0
   * @memberof WdOrdersService
   */
  constructor(
    private translate: TranslateService,
    private wdEnvironmentService: WdLocalEnvironmentService,
    private wdTranslate: TranslateService,
    public wdLocalSharedFunctionsService: WdLocalSharedFunctionsService,
    public wdOrdersV2Service: WdOrdersV2Service,
    @Inject('wdDateTimeHelper') public wdDateTimeHelper: IBcxDateTimeHelper,
    @Inject('wdErrorService') public wdErrorService: IBcxErrorService,
    @Inject('wdOauth2HttpService')
    public wdOauth2HttpService: IBcxOauth2HttpService,
    @Inject('wdSharedFunctionsService')
    public wdSharedFunctionsService: IBcxSharedFunctionsService,
    @Inject('wdStorageService') public wdStorageService: IBcxStorageService,
  ) {
    // Set tha data export API url
    this.dataExportApiUrl = this.wdEnvironmentService.configuration.getDataExportApiPath;

    this.currencySymbolTranslationKey =
      'locales.currency_symbol_' +
      this.wdEnvironmentService.constants.getLocaleCurrencyUnit;
  }

  // Local Storage Key
  localStorageKey = 'orderAdminV2';

  // Booleans
  isAddingLookaheadOrder = new BehaviorSubject(true); // Adding Lookahead Order

  isUpdatingOrder = new BehaviorSubject(false); // Updating Orders

  // API Urls
  dataExportApiUrl = ''; // Data Export API

  // Variables
  orderFulfillmentCountMax = 0;
  currencySymbolTranslationKey = '';

  // All and Visible List Order Columns
  orderListColumns: Array<string> = [];
  orderListColumnsOptions: Array<ITableColumnOptions> = [];

  // Order Fulfillment Group Variables
  columnWidthFgs = 0;
  selectedFgs: Array<any> = [];

  // Selections
  orderListSelections = new SelectionModel(true, [] as any);

  /**
   * Build POST data for lookahead order
   * @since 4.36.0
   */
  private static buildLookaheadOrderPostData(input: any) {
    const result: any = {};

    // result.attachments = [];
    result.dateRequired = input.dateRequested?.toISOString(); // Requested Date
    result.dateProduction = input.dateProduction?.toISOString(); // Production Date
    result.dateDelivery = input.dateShipping?.toISOString(); // Shipping Date
    result.delivery = { option: 'jobSite' };
    result.job = input.job;
    result.job.phase = input.phase;
    result.measuredBy = input.measuredBy; // Measured By
    result.orderedFor = { id: input.orderedFor?.id }; // OrderedFor
    result.poNumber = input.poNumber; // PO Number
    result.specialInstructions = input.description; // Instructions / Description
    result.tag = input.label; // Tag / Label
    result.lookahead = true; // Lookahead Toggle
    result.userGroupId = input.userGroup?.id; // User Group ID

    return result;
  }

  /**
   * Build PUT data for order based on section being edited using the PUT orders parameter names in order-api
   * @since 4.62.0
   */
  private buildOrderPutData(key: string, model: any, state: any) {
    const result: any = {};
    const apiDateFormat = 'YYYY-MM-DD';
    const updatedData = model[key];
    const originalData = JSON.parse(
      state[key].beforeChanges,
      WdLocalSharedFunctionsService.revertSectionDateReviver,
    );

    if (key === this.wdLocalSharedFunctionsService.orderSectionType.DATES) {
      // Production Start Date
      if (
        updatedData.productionStart.toString() !==
        originalData.productionStart.toString()
      ) {
        // The production start date is serialized as productionDate
        result.productionDate = this.wdDateTimeHelper.getDateAsString(
          updatedData.productionStart,
          apiDateFormat,
        );
      }

      // Production End Date
      if (
        updatedData.productionEnd.toString() !==
        originalData.productionEnd.toString()
      ) {
        result.productionEndDate = this.wdDateTimeHelper.getDateAsString(
          updatedData.productionEnd,
          apiDateFormat,
        );
      }

      // Shipping Date
      if (
        updatedData.delivery.toString() !== originalData.delivery.toString()
      ) {
        result.shippingDate = this.wdDateTimeHelper.getDateAsString(
          updatedData.delivery,
          apiDateFormat,
        );
      }
    }
    if (key === this.wdLocalSharedFunctionsService.orderSectionType.DETAILS) {
      // Measured By
      if (updatedData.measuredBy !== originalData.measuredBy) {
        result.measuredBy = updatedData.measuredBy;
      }
      // Tag
      if (updatedData.tag !== originalData.tag) {
        result.tag = updatedData.tag;
      }
      // PO Number
      if (updatedData.poNumber !== originalData.poNumber) {
        result.poNumber = updatedData.poNumber;
      }
      // Ordered For
      if (
        updatedData.orderedFor &&
        updatedData.orderedFor?.id !== originalData.orderedFor?.id
      ) {
        result.orderedForUserId = updatedData.orderedFor?.id;
      }
      // User Group
      if (
        updatedData.userGroup &&
        updatedData.userGroup?.id !== originalData.userGroup?.id
      ) {
        result.userGroupId = updatedData.userGroup?.id;
      }
    }
    if (
      key === this.wdLocalSharedFunctionsService.orderSectionType.FORMFIELDS
    ) {
      if (updatedData !== originalData) {
        result.formFields = updatedData;
      }
    }
    if (key === this.wdLocalSharedFunctionsService.orderSectionType.JOB) {
      // Job Changes
      if (updatedData !== originalData) {
        // Job Changed
        if (updatedData.job && updatedData.job !== originalData.job) {
          // Set Job Details
          if (updatedData.job.index) {
            // Used when forceJobSelection = true
            result.jobId = updatedData.job.index;
          } else {
            // Used when forceJobSelection = false
            result.jobName = updatedData.job.name;
            result.jobNumber = updatedData.job.number;
          }

          // Override Changed
          if (
            updatedData.job.override &&
            updatedData.job.override !== originalData.job.override
          ) {
            result.jobName = updatedData.job.override.name;
            result.jobNumber = updatedData.job.override.number;
          }
        }

        // Set Phase
        result.phaseId = null;

        // Phase Changed
        if (updatedData.phase && updatedData.phase !== originalData.phase) {
          // Set Phase
          result.phaseId = updatedData.phase.id;
        }
      }
    }
    if (
      key === this.wdLocalSharedFunctionsService.orderSectionType.INSTRUCTIONS
    ) {
      // Special Instructions
      if (updatedData !== originalData) {
        result.specialInstructions = updatedData;
      }
    }
    if (key === this.wdLocalSharedFunctionsService.orderSectionType.STATUSES) {
      // Overall Status
      if (updatedData.overall?.id !== originalData.overall?.id) {
        result.statusId = updatedData.overall?.id;
      }
      // Shipping Status
      if (updatedData.shipping?.id !== originalData.shipping?.id) {
        result.shippingStatusId = updatedData.shipping?.id;
      }
    }
    if (key === this.wdLocalSharedFunctionsService.orderSectionType.SHIPPING) {
      const updatedShippingData =
        model[this.wdLocalSharedFunctionsService.orderSectionType.SHIPPING];
      const originalShippingData = JSON.parse(
        state[this.wdLocalSharedFunctionsService.orderSectionType.SHIPPING]
          .beforeChanges,
      );
      // Shipping option
      if (updatedShippingData.option?.id !== originalShippingData.option?.id) {
        result.shippingOptionId = updatedShippingData.option?.value;
      }

      // Shipping loading zone option
      if (
        updatedShippingData.loadingZone?.id !==
        originalShippingData.loadingZone?.id
      ) {
        result.loadingZoneId = updatedShippingData.loadingZone
          ? updatedShippingData.loadingZone.id
          : null;
      }

      // Shipping vehicle option
      if (
        updatedShippingData.vehicle?.id !== originalShippingData.vehicle?.id
      ) {
        result.vehicleId = updatedShippingData.vehicle
          ? updatedShippingData.vehicle.id
          : null;
      }

      // Shipping address
      if (
        updatedData.address &&
        originalData.address &&
        updatedShippingData.option?.value === OrderShippingOptions.ADDRESS
      ) {
        const updatedAddress = updatedData.address;
        const originalAddress = originalData.address;

        if (updatedAddress.city !== originalAddress.city) {
          result.shipToCity = updatedData.address.city;
        }

        if (updatedAddress.company !== originalAddress.company) {
          result.shipToCompany = updatedData.address.company;
        }

        if (
          updatedAddress.country &&
          originalAddress.country &&
          !isEqual(updatedAddress.country, originalAddress.country)
        ) {
          result.shipToCountryCode = updatedData.address.country.id;
          result.shipToCountryLabel = updatedData.address.country.label;
        }

        if (updatedAddress.phone !== originalAddress.phone) {
          result.shipToPhone = updatedData.address.phone;
        }

        if (
          updatedAddress.state &&
          originalAddress.state &&
          !isEqual(updatedAddress.state, originalAddress.state)
        ) {
          result.shipToStateCode = updatedData.address.state.id;
          result.shipToStateLabel = updatedData.address.state.label;
        }

        if (updatedAddress.street !== originalAddress.street) {
          result.shipToStreet = updatedData.address.street;
        }

        if (updatedAddress.zipcode !== originalAddress.zipcode) {
          result.shipToZipCode = updatedData.address.zipcode;
        }
      }

      // Shipping start time
      if (
        !isEqual(
          updatedData.startTime?.objectValue,
          originalShippingData.startTime?.objectValue,
        )
      ) {
        result.deliveryStartTime = updatedData.startTime?.objectValue
          ? this.buildDeliveryTime(updatedData.startTime.objectValue)
          : null;
      }

      // Shipping end time
      if (
        !isEqual(
          updatedData.endTime?.objectValue,
          originalShippingData.endTime?.objectValue,
        )
      ) {
        result.deliveryEndTime = updatedData.endTime?.objectValue
          ? this.buildDeliveryTime(updatedData.endTime.objectValue)
          : null;
      }
    }
    return result;
  }

  /**
   * Convert time object value to date iso string
   *
   * @since 4.62.0
   */
  private buildDeliveryTime(timeObjectValue: any): string {
    const { hour, minute, second } = timeObjectValue;
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(second);
    return date.toISOString();
  }

  /**
   * Add Lookahead Order
   * @since 4.36.0
   */
  async addLookaheadOrder(inputData: any): Promise<void> {
    // Toggle Loader
    this.isAddingLookaheadOrder.next(true);
    try {
      // Format data for POST
      const postData = WdOrdersService.buildLookaheadOrderPostData(inputData);
      // Add Lookahead Order
      await this.wdOauth2HttpService.post(
        `${this.wdLocalSharedFunctionsService.orderingApiUrl}orders`,
        postData,
      );
      // Success Message
      this.wdErrorService.userSuccess(
        this.wdTranslate.instant('labels.success'),
        this.wdTranslate.instant('outputs.successfullyAdded', {
          type: this.wdTranslate.instant('order.types.lookahead.title'),
        }),
      );
    } catch (error) {
      // Error Message
      this.wdErrorService.userError(
        this.wdTranslate.instant('labels.error'),
        error.statusText,
      );
      throw error;
    } finally {
      // Toggle Loader
      this.isAddingLookaheadOrder.next(false);
    }
  }

  /**
   * PUT Updates order details
   *
   * @since 4.36.0
   * @memberof WdOrdersService
   */
  async updateOrder(key: string, model: any, state: any): Promise<void> {
    // Toggle Loader
    this.isUpdatingOrder.next(true);

    try {
      // Set Variables
      const index =
        model[this.wdLocalSharedFunctionsService.orderSectionType.DETAILS]
          .index;

      // Format data for PUT
      const putData = this.buildOrderPutData(key, model, state);

      if (
        key === this.wdLocalSharedFunctionsService.orderSectionType.JOB &&
        model.isEcommerce
      ) {
        // Update Job Override
        await this.wdOrdersV2Service.updateOrderJobOverride(index, putData);
      } else {
        // Update Order Details
        await this.wdOauth2HttpService.put(
          `${this.wdLocalSharedFunctionsService.orderApiUrl}orders/${index}?idType=indexId`,
          putData,
        );
        // Success Message
        this.wdErrorService.userSuccess(
          this.wdTranslate.instant('labels.success'),
          this.wdTranslate.instant('outputs.successfullyUpdated', {
            type: this.wdTranslate.instant('order.title.singular'),
          }),
        );
      }
    } catch (error) {
      // Error Message
      this.wdErrorService.userError(
        this.wdTranslate.instant('labels.error'),
        this.wdTranslate.instant('outputs.errorUpdating', {
          type: this.wdTranslate.instant('order.title.singular'),
        }),
      );
      throw error;
    } finally {
      // Toggle Loader
      this.isUpdatingOrder.next(false);
    }
  }

  /**
   * PUT Updates items status for an order
   *
   * @since 4.26.0
   * @memberof WdOrdersService
   */
  async updateOrderItemShippingStatuses(
    id: string,
    itemIds: Array<string>,
    statusId: string,
  ): Promise<void> {
    // Toggle Loader
    this.isUpdatingOrder.next(true);
    try {
      await this.wdOauth2HttpService.put(
        `${this.wdLocalSharedFunctionsService.orderApiUrl}orders/${id}`,
        {
          itemIds: itemIds,
          itemShippingStatusId: statusId,
        },
      );
      // Success Message
      this.wdErrorService.userSuccess(
        this.wdTranslate.instant('labels.success'),
        this.wdTranslate.instant('outputs.successfullyUpdated', {
          type: this.wdTranslate.instant('order.items.status.description'),
        }),
      );
    } catch (error) {
      // Error Message
      this.wdErrorService.userError(
        this.wdTranslate.instant('labels.error'),
        this.wdTranslate.instant('outputs.errorUpdating', {
          type: this.wdTranslate.instant('order.items.status.description'),
        }),
      );
    } finally {
      // Toggle Loader
      this.isUpdatingOrder.next(false);
    }
  }

  /**
   * Initialize Local Storage Settings
   * @since 4.34.0
   */
  initializeLocalStorage() {
    // Local storage key
    const localStorageKey = this.localStorageKey;
    if (this.wdStorageService[localStorageKey]) {
      this.wdOrdersV2Service.orderViewSettings = this.wdStorageService[
        localStorageKey
      ];
    }
    this.wdStorageService.initializeDefaults(
      localStorageKey,
      this.wdOrdersV2Service.orderViewSettings,
    );
    this.wdOrdersV2Service.orderViewSettings = this.wdStorageService[
      localStorageKey
    ];
  }

  /**
   * Initialize Order Columns
   * @since 4.38.0
   */
  initOrderListColumnsOptions(orderType: string) {
    // Selected columns from local storage
    const savedColumns: Array<string> = this.wdOrdersV2Service.orderViewSettings
      .selected.columns[orderType];
    // Initialize Translations
    this.translate.get('order.columns.toggle.title').subscribe(() => {
      // Init results
      const results: Array<any> = [];
      // Set Translations
      const options: Array<any> = [];

      options.push(
        {
          key: 'select',
          label: '',
          lookahead: true,
          work: true,
          canToggle: false,
        },
        {
          key: 'number',
          label: '',
          lookahead: true,
          work: true,
          canToggle: false,
        },
        {
          key: 'lookahead',
          label: this.translate.instant('order.columns.lookahead.title'),
          lookahead: true,
          work: false,
          canToggle: true,
        },
        {
          key: 'job',
          label: this.translate.instant('order.columns.job.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
        {
          key: 'user',
          label: this.translate.instant('order.columns.user.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
        {
          key: 'poNumber',
          label: this.translate.instant('order.columns.poNumber.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
        {
          key: 'tag',
          label: this.translate.instant('order.columns.tag.title'),
          lookahead: false,
          work: true,
          canToggle: true,
        },
        {
          key: 'groups',
          label: this.translate.instant('order.columns.groups.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
        {
          key: 'ordered',
          label: this.translate.instant('order.columns.ordered.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
        {
          key: 'production',
          label: this.translate.instant('order.columns.production.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
        {
          key: 'shipping',
          label: this.translate.instant('order.columns.shipping.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        },
      );
      // Only show weight with required permissions
      if (this.wdEnvironmentService.permissions.canViewWeight) {
        options.push({
          key: 'weight',
          label: this.translate.instant('order.columns.weight.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        });
      }
      options.push({
        key: 'price',
        label: this.translate.instant('order.columns.price.title'),
        lookahead: true,
        work: true,
        canToggle: true,
      });
      // Only show fabrication time with required permissions
      if (this.wdEnvironmentService.permissions.canViewFabricationTime) {
        options.push({
          key: 'labour',
          label: this.translate.instant('order.columns.labour.title'),
          lookahead: true,
          work: true,
          canToggle: true,
        });
      }
      options.push({
        key: 'progress',
        label: this.translate.instant('order.columns.progress.title'),
        lookahead: false,
        work: true,
        canToggle: true,
      });
      options.push({
        key: 'options',
        label: '',
        lookahead: true,
        work: true,
        canToggle: false,
      });

      // Set options
      options.forEach((column: any) => {
        // Is column selected?
        column.selected =
          savedColumns.length > 0 ? savedColumns.includes(column.key) : true;
        // Is column visible
        if (
          (orderType ===
            this.wdLocalSharedFunctionsService.orderTypeKey.LOOKAHEAD &&
            column.lookahead) ||
          (orderType === this.wdLocalSharedFunctionsService.orderTypeKey.WORK &&
            column.work)
        ) {
          results.push(column);
        }
      });
      // Set columns
      this.orderListColumnsOptions = results;
      // Set order list columns
      this.setOrderListColumns(orderType);
    });
  }

  /**
   * Save Local Storage Settings
   * @since 4.34.0
   */
  saveLocalStorageSettings() {
    this.wdStorageService.saveLocalStorageConfiguration(
      this.localStorageKey,
      this.wdOrdersV2Service.orderViewSettings,
    );
  }

  /**
   * Save Selected Filters in Settings
   *
   * @since 4.34.0
   */
  saveSelectedFilters() {
    // All Filter Values
    const filtersData = this.wdOrdersV2Service.orderFilters.value;

    // Selected Filter Settings
    const selectedFilterSettings = this.wdOrdersV2Service.orderViewSettings
      .selected;

    // Set Last Known Totals (used on initial data load to check which filters are needed)
    selectedFilterSettings.groups.fulfillment.total =
      filtersData.fulfillmentGroups?.length;
    selectedFilterSettings.groups.user.total = filtersData.userGroups?.length;
    selectedFilterSettings.statuses.shipping.total =
      filtersData.deliveryStatuses?.length;
    selectedFilterSettings.statuses.order.total =
      filtersData.orderStatuses?.length;
    selectedFilterSettings.statuses.production.total =
      filtersData.productionStatuses?.length;
    selectedFilterSettings.types.shipping.total =
      filtersData.orderShippingTypes?.length;
    selectedFilterSettings.types.seat.total = filtersData.seatTypes?.length;

    // Set Selected Groups / Statuses / Shipping Types
    selectedFilterSettings.groups.fulfillment.indexes = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.fulfillmentGroups,
      'index',
    );
    selectedFilterSettings.groups.user.ids = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.userGroups,
      'id',
    );
    selectedFilterSettings.statuses.shipping.indexes = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.deliveryStatuses,
      'index',
    );
    selectedFilterSettings.statuses.order.ids = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.orderStatuses,
      'id',
    );
    selectedFilterSettings.statuses.production.indexes = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.productionStatuses,
      'index',
    );
    selectedFilterSettings.types.shipping.values = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.orderShippingTypes,
      'value',
    );
    selectedFilterSettings.types.seat.values = this.wdLocalSharedFunctionsService.getSelectedFiltersValuesByKey(
      filtersData.seatTypes,
      'bcxId',
    );

    // Save Local Storage Settings
    this.saveLocalStorageSettings();
  }

  /**
   * set Dynamic Fulfillment Group Column Sizing
   * @since 4.34.0
   */
  setFulfillmentGroupColumnSizing(): void {
    // Fulfillment groups selected in filters
    const fgColumnSelectedFgs = this.wdSharedFunctionsService.getDescendantProperty(
      this.wdOrdersV2Service.orderViewSettings,
      'selected.groups.fulfillment.indexes',
    );
    // Total deployment fulfillment groups
    const fgColumnTotalFgs = this.wdSharedFunctionsService.getDescendantProperty(
      this.wdOrdersV2Service.orderFilters,
      'value.fulfillmentGroups',
    );
    const widthPercentageMultiplier = 2.6; // Percentage width for each fulfillment group
    let fgColumnWidth = fgColumnTotalFgs?.length; // Total Fulfillment Groups

    if (fgColumnTotalFgs) {
      const showEmptyFulfillmentGroups = this.wdOrdersV2Service
        .orderViewSettings.groups.fulfillment.showEmpty; // Show empty groups
      const fgColumnWidthMin = 3; // Minimum column width
      // If empty fulfillment groups are toggled
      if (showEmptyFulfillmentGroups) {
        const fgColValue = fgColumnSelectedFgs
          ? fgColumnSelectedFgs.length
          : fgColumnWidth;
        fgColumnWidth =
          fgColValue > fgColumnWidthMin ? fgColValue : fgColumnWidthMin;
      } else {
        // Set fulfillment group width to fit order fulfillment groups
        const fgColValue = this.orderFulfillmentCountMax;
        fgColumnWidth =
          fgColValue > fgColumnWidthMin ? fgColValue : fgColumnWidthMin;
      }
    }
    // Total selected fulfillment groups
    this.columnWidthFgs = fgColumnWidth * widthPercentageMultiplier;
    this.selectedFgs = fgColumnSelectedFgs ? fgColumnSelectedFgs.length : 0;
  }

  /**
   * Set Visible Order Columns
   * @since 4.38.0
   */
  setOrderListColumns(orderType: string) {
    // Init columns
    const results: Array<any> = [];

    // Add columns based on restrictions
    this.orderListColumnsOptions.forEach((column) => {
      // Column is toggled ON in settings
      const isColumnToggledOn = column.selected;
      switch (column.key) {
        case 'select':
          // Select column cannot be toggled off manually. Only based on permissions.
          if (this.wdEnvironmentService.permissions.canChangeOrderStatus) {
            results.push(column.key);
          }
          break;
        case 'lookahead':
          if (
            isColumnToggledOn &&
            orderType ===
              this.wdLocalSharedFunctionsService.orderTypeKey.LOOKAHEAD
          ) {
            results.push(column.key);
          }
          break;
        case 'tag':
          if (
            isColumnToggledOn &&
            orderType !==
              this.wdLocalSharedFunctionsService.orderTypeKey.LOOKAHEAD
          ) {
            results.push(column.key);
          }
          break;
        default:
          if (isColumnToggledOn) {
            // Add standard columns
            results.push(column.key);
          }
      }
    });

    // Set columns
    this.orderListColumns = results;
    this.wdOrdersV2Service.orderViewSettings.selected.columns[
      orderType
    ] = results;
    this.saveLocalStorageSettings();
  }
}
